/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../components/header/index'
import Hero from '../components/heros/index'
import Container from '../components/container'
import Card from '../components/partnerCard'
import CTO from '../components/cto'
import Footer from '../components/footer'
import Title from '../components/title'
// Images
import MCServerTime from '../images/partners/mcservertime.webp'
import Tebex from '../images/partners/tebex.webp'

const Partners = () => {
    Title('Partners - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Official Partners' description='View our official partners, companies and brands we work closely with' />
            </div>
            <section className='partners py-28'>
                <Container>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-20'>
                        <Card name='MCServerTime' logo={MCServerTime} twitter='https://twitter.com/MCServerTimeCOM' url='https://mcservertime.com/' discord='https://discord.com/invite/nHTvmmm7C4' description='MCServerTime is an amazing Java Minecraft server list that provides Minecraft server owners with FREE/PAID Minecraft server advertising solutions. Paid options are affordable and proven to increase server popularity and exposure!' />
                        <Card name='Tebex' logo={Tebex} twitter='https://twitter.com/TebexSupport' url='https://affiliate.tebex.io/r/3315eb37-f000-4859-9251-1debb3364366' description='Tebex is the #1 Minecraft server payment processing solution for personal and professional servers alike. They scale with you as your server grows, you never have to worry about the stability, uptime, or accessibility of your server.' />
                    </div>
                </Container>
            </section>
            <CTO />
            <Footer />
        </main>
    )
}

export default Partners